import { db, storage } from "../../../firebase/firebase-config";

export const getHomeConfigBanner = async (key) => {
  const doc = await db.collection("home_config").doc(key).get();
  return doc.exists ? { id: doc.id, ...doc.data() } : null;
};

export const setHomeConfigBanner = async (key, data) => {
  const rawItems = Array.isArray(data.items) ? data.items : [];
  const items = [];

  for (const [index, item] of rawItems.entries()) {
    let imageURL = item.imageURL || "";
    if (item.file) {
      const safeName = item.file.name.replace(/[^\w.-]/g, "_");
      const ref = storage.ref().child(`home_config/${key}/items/${Date.now()}_${index}_${safeName}`);
      await ref.put(item.file);
      imageURL = await ref.getDownloadURL();
    }
    if (!imageURL && !item.title && !item.subtitle && !item.clickMe) continue;
    items.push({
      title: item.title || "",
      subtitle: item.subtitle || "",
      clickMe: item.clickMe || "",
      imageURL,
      order: index,
    });
  }

  const first = items[0] || {};
  const imageURLs = items.map((item) => item.imageURL).filter(Boolean);

  await db.collection("home_config").doc(key).set(
    {
      title: first.title || "",
      subtitle: first.subtitle || "",
      clickMe: first.clickMe || "",
      imageURL: first.imageURL || "",
      imageURLs,
      items,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
};
